import styles from './Timeline.module.scss';

import {Signal} from '@preact/signals-react';
import {useTimelineContext} from '../../contexts';
import {usePlayerTime, usePreviewSettings} from '../../hooks';

interface PlayheadProps {
  seeking: Signal<number | null>;
}

export function Playhead({seeking}: PlayheadProps) {
  const {framesToPixels} = useTimelineContext();
  const {fps} = usePreviewSettings();
  const time = usePlayerTime();
  const frame = seeking.value ?? time.frame;

  return (
    <div
      className={styles.playhead}
      data-frame={formatTime(frame, fps)}
      style={{
        left: `${framesToPixels(frame)}px`,
      }}
    />
  );
}

function formatTime(frame: number, fps: number): string {
  const totalSeconds = Math.floor(frame / fps);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}
